import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import styles from "../../../constants/assets/variables";
import ToggleSwitch from "../../Common/ToggleSwitch";
import { getInitialState } from "../../../utils";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TelecallerActions from "../../../store/actions/Telecaller";
import "./TelecallersFormModal.scss";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const TelecallersFormModal = ({
  handleClose,
  modalState,
  getTelecaller,
  activeId,
  activeTelecaller,
  clusters = [],
  activeFilters,
  updateTelecaller,
  currentPage,
  getTelecallerProfiles,
}) => {
  const [initialState, setInitialState] = useState({
    active: false,
    bandwidth: 0,
    primary_cluster: "",
    secondary_cluster: "",
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  });
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const handleFilterClick = () => {
    console.log("Filters...");
  };

  const handleSubmit = () => {
    updateTelecaller(activeId, initialState).then((res) => {
      if (res) {
        const pageRequest = { page_number: currentPage };
        getTelecallerProfiles({}, pageRequest);
        handleClose();
      }
    });
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    if (key === "bandwidth") {
      values[key] = parseInt(val);
    } else {
      values[key] = val;
    }
    setInitialState(values);
  };

  const getHeading = () => {
    if (modalState === "Filter") {
      return "Filter Profiles";
    } else if (modalState === "Add") {
      return "Add Telecaller Profile";
    } else {
      return "Update Telecaller Profile";
    }
  };

  useEffect(() => {
    if (activeId && modalState === "Edit") {
      getTelecaller(activeId);
    }
  }, [activeId]);

  useEffect(() => {
    //set the initial state of form in modal
    if (Object.keys(activeTelecaller).length > 0 && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).forEach((key, idx) => {
        values[key] = activeTelecaller[key]
          ? activeTelecaller[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
    if (Object.keys(activeFilters).length > 0 && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).forEach((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeTelecaller, activeFilters]);

  return (
    <NoFooterModal
      header
      heading={getHeading()}
      handleClose={handleClose}
      id="telecallersFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          {modalState === "Filter" && (
            <Button
              data-testid="telecallersFormClearBtn"
              onClick={handleClose}
              className="sushi-btn"
            >
              Clear
            </Button>
          )}
          <Button
            data-testid="telecallersFormSubmitBtn"
            onClick={modalState === "Filter" ? handleFilterClick : handleSubmit}
            className="sushi-btn"
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </BottomSectionModal>
      }
    >
      <div id="telecaller-form">
        <PaginatedReactDropdown
          options={clusters}
          keyToChange="primary_cluster"
          placeholder="Primary Cluster"
          handleChange={handleChange}
          value={initialState.primary_cluster}
          showCross={true}
          id="primaryClusterDropdown"
        />
        <PaginatedReactDropdown
          options={clusters}
          keyToChange="secondary_cluster"
          placeholder="Secondary Cluster"
          handleChange={handleChange}
          value={initialState.secondary_cluster}
          showCross={true}
          id="secondaryClusterDropdown"
        />

        <Input
          type="number"
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          onChange={(e) => handleChange("bandwidth", e)}
          value={initialState.bandwidth}
          label="Bandwidth"
        />

        <ToggleSwitch
          id="sushi-switch"
          className="semibold"
          size={11}
          spacing={3}
          isActive={initialState.active}
          handleChange={handleChange}
          keyName="active"
          label="Is Active?"
        />

        <div className="available-days-container">
          <h4>Available Days</h4>
          <div className="available-days-holder flex items-center justify-between flex-wrap">
            {days.map((day, index) => {
              return (
                <ToggleSwitch
                  id={"sushi-switch" + index}
                  className="semibold"
                  size={11}
                  spacing={3}
                  isActive={initialState[day.toLowerCase()]}
                  handleChange={handleChange}
                  keyName={day.toLowerCase()}
                  label={day}
                />
              );
            })}
          </div>
        </div>
      </div>
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { Telecaller } = state;
  return {
    activeTelecaller: Telecaller.activeTelecaller,
    activeFilters: Telecaller.activeFilters,
    currentPage: Telecaller.currentPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTelecaller: bindActionCreators(
      TelecallerActions.getTelecaller,
      dispatch
    ),
    updateTelecaller: bindActionCreators(
      TelecallerActions.updateTelecaller,
      dispatch
    ),
    getTelecallerProfiles: bindActionCreators(
      TelecallerActions.getTelecallerProfiles,
      dispatch
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TelecallersFormModal);
